export default __webpack_public_path__ + "static/media/upheaval.cbdcb764.png";